module.exports = __webpack_public_path__ + "img/case_pic01.4abd513f.png";